import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import type { ControlledResource, Intent } from '../../types/profiles';

interface CanProps {
  resource: ControlledResource;
  intent?: Intent;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Conditionally renders `children` when the effective user's profile grants
 * the given (resource, intent). Returns `fallback` (or null) otherwise.
 */
export const Can: React.FC<CanProps> = ({ resource, intent = 'read', fallback = null, children }) => {
  const { can } = usePermissions();
  return <>{can(resource, intent) ? children : fallback}</>;
};
